export type CustomLanding36252State = {
  dismissed: boolean;
  language: string
  languageSelectorOpen: boolean
}

export enum CustomLanding36252ActionType {
  ChangeLanguageAction = 'ChangeLanguageAction',
  Dismiss = 'Dismiss',
  OpenLanguageSelector = 'OpenLanguageSelector',
}

export type CustomLanding36252ChangeLanguageAction = {
  type: CustomLanding36252ActionType.ChangeLanguageAction
  payload: string
}

export type CustomLanding36252OpenLanguageSelectorAction = {
  type: CustomLanding36252ActionType.OpenLanguageSelector
}

export type CustomLanding36252DismissAction = {
  type: CustomLanding36252ActionType.Dismiss
}

export type CustomLanding36252Action =
  | CustomLanding36252ChangeLanguageAction
  | CustomLanding36252OpenLanguageSelectorAction
  | CustomLanding36252DismissAction
